import { render, staticRenderFns } from "./ProductImageSlider.vue?vue&type=template&id=63c10bb2&scoped=true&"
import script from "./ProductImageSlider.vue?vue&type=script&lang=ts&"
export * from "./ProductImageSlider.vue?vue&type=script&lang=ts&"
import style0 from "./ProductImageSlider.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductImageSlider.vue?vue&type=style&index=1&id=63c10bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c10bb2",
  null
  
)

export default component.exports